import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarVoiceIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M10 12.5a3.33 3.33 0 0 0 3.33-3.33v-5a3.33 3.33 0 1 0-6.66 0v5A3.33 3.33 0 0 0 10 12.5ZM8.33 4.17a1.67 1.67 0 0 1 3.34 0v5a1.67 1.67 0 0 1-3.34 0v-5Zm8.34 5a.83.83 0 1 0-1.67 0 5 5 0 1 1-10 0 .83.83 0 1 0-1.67 0 6.67 6.67 0 0 0 5.84 6.6v1.73H7.5a.83.83 0 1 0 0 1.67h5a.83.83 0 0 0 0-1.67h-1.67v-1.72a6.67 6.67 0 0 0 5.84-6.61Z"
      fill="#5C64ED"
    />
    <path
      d="M10 12.5a3.33 3.33 0 0 0 3.33-3.33v-5a3.33 3.33 0 1 0-6.66 0v5A3.33 3.33 0 0 0 10 12.5ZM8.33 4.17a1.67 1.67 0 0 1 3.34 0v5a1.67 1.67 0 0 1-3.34 0v-5Zm8.34 5a.83.83 0 1 0-1.67 0 5 5 0 1 1-10 0 .83.83 0 1 0-1.67 0 6.67 6.67 0 0 0 5.84 6.6v1.73H7.5a.83.83 0 1 0 0 1.67h5a.83.83 0 0 0 0-1.67h-1.67v-1.72a6.67 6.67 0 0 0 5.84-6.61Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1=".83"
        x2="10"
        y2="19.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarVoiceIcon.defaultProps = {
  sx: null,
}
